//src/components/layout/menuConfig.js
export const adminMenu = [
  {
    section: "Transactions",
    items: [
      { label: "Tableau de bord", path: "/admin/analytics", icon: "Analytics" },
      { label: "Transactions", path: "/admin/transactions", icon: "ReceiptLong" },
      { label: "Nouvelle transaction", path: "/transactions/create", icon: "AddCircle" },
    ],
  },
  {
    section: "Administration",
    items: [
      { label: "Agents", path: "/admin/agents", icon: "PeopleAltOutlined" },
      { label: "Créer un agent", path: "/admin/agents/register", icon: "PersonAddAlt1" },
      { label: "Administrateurs", path: "/admin/admins", icon: "AdminPanelSettings" },
    ],
  },
  {
    section: "Mobile Money",
    items: [
      { label: "Tableau de bord mobile", path: "/mobile-dashboard", icon: "Analytics" },
      { label: "Retraits mobiles", path: "/mobile-payouts", icon: "Payments" },
      { label: "Transactions SMS", path: "/sms-transactions", icon: "ReceiptLong" },
      { label: "Comptes Mobile Money", path: "/admin/mobile-money-accounts", icon: "AccountBalanceWallet" },
    ],
  },
  {
    section: "Gestion financière",
    items: [
      { label: "Vue financière", path: "/financial-dashboard", icon: "AccountBalance" },
      { label: "Caisses", path: "/cashboxes", icon: "AccountBalanceWallet" },
      { label: "Approvisionnements", path: "/cash-fundings", icon: "AttachMoney" },
      { label: "Dépenses", path: "/expenses", icon: "MoneyOff" },
      { label: "Salaires", path: "/salary-payments", icon: "Payments" },
      { label: "Débiteurs", path: "/debtors", icon: "PersonOutline" },
      { label: "Prêts", path: "/loans", icon: "RequestQuote" },
    ],
  },
  {
    section: "Configuration",
    items: [
      { label: "Commission mobile", path: "/admin/settings/mobile-commission", icon: "Settings" },
      { label: "Paramètres", path: "/admin/settings/fee", icon: "Settings" },
    ],
  },
];

export const agentMenu = [
  { section: "Mobile Money", items: [{ label: "Tableau de bord mobile", path: "/mobile-dashboard", icon: "Analytics" },
      { label: "Retraits mobiles", path: "/mobile-payouts", icon: "Payments" },
      { label: "Transactions SMS", path: "/sms-transactions", icon: "ReceiptLong" }] },
  {
    section: "Transactions",
    items: [
      { label: "Tableau de bord", path: "/agent", icon: "Dashboard" },
      { label: "Transactions", path: "/transactions", icon: "ListAlt" },
      { label: "Nouvelle transaction", path: "/transactions/create", icon: "AddCircle" },
    ],
  },
  {
    section: "Caisse",
    items: [
      { label: "Caisses", path: "/cashboxes", icon: "AccountBalanceWallet" },
      { label: "Approvisionnements", path: "/cash-fundings", icon: "AttachMoney" },
      { label: "Dépenses", path: "/expenses", icon: "MoneyOff" },
      { label: "Salaires", path: "/salary-payments", icon: "Payments" },
      { label: "Débiteurs", path: "/debtors", icon: "PersonOutline" },
      { label: "Prêts", path: "/loans", icon: "RequestQuote" },
      { label: "Vue financière", path: "/financial-dashboard", icon: "AccountBalance" },
    ],
  },
];
